<div class="young-adults-schools" *ngIf="youngAdultsSchools$ | async as youngAdultsSchools">
  <lx-price-lists-portal-price-list-panel
    [priceListFilters]="youngAdultsFilters$ | async"
    [withData]="youngAdultsSchools?.schools?.length > 0"
    (filtersChanged)="filterYoungAdultsSchools($event)"
  >
    <lx-price-lists-portal-young-adults-price-list-data [schools]="youngAdultsSchools?.schools"></lx-price-lists-portal-young-adults-price-list-data>
  </lx-price-lists-portal-price-list-panel>
</div>
